export enum Roles {
    HILL_OWNER = 'hill-owner',
    HILL_OPERATOR = 'hill-operator',
    TSLINK_ADMIN = 'tslink-admin',
}
